import { CatalogTypePage } from './CatalogTypePage';
import { CatalogDrawerFormPage } from './CatalogDrawerFormPage';

const SHARED = {
  type: 'DRAWER' as const,
  i18nNs: 'drawers',
  listTo: '/drawers' as const,
  newTo: '/drawers/new' as const,
  editToParent: '/drawers/$id' as const,
  editParentRouteId: '/protected/drawers/$id' as const,
};

export function DrawersListPage() {
  return (
    <CatalogTypePage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      listTo={SHARED.listTo}
      newTo={SHARED.newTo}
      editToParent={SHARED.editToParent}
    />
  );
}

export function DrawerCreatePage() {
  return <CatalogDrawerFormPage mode="create" />;
}

export function DrawerEditPage() {
  return <CatalogDrawerFormPage mode="edit" />;
}
